module.exports = __webpack_public_path__ + "static/media/white-circle-measure-icon.87b52f40.svg";